import { render, staticRenderFns } from "./TigerSchoolFootBanner.vue?vue&type=template&id=51647d07&scoped=true"
import script from "./TigerSchoolFootBanner.vue?vue&type=script&lang=ts"
export * from "./TigerSchoolFootBanner.vue?vue&type=script&lang=ts"
import style0 from "./TigerSchoolFootBanner.vue?vue&type=style&index=0&id=51647d07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51647d07",
  null
  
)

export default component.exports